import { cn } from '@zep/utils';
import { heroServiceButtons, heroVideoUrls } from '../../../../consts/landingConsts';
import { useLocale } from '../../../../hooks';
interface HeroVideoProps {
  activeServiceIndex: number;
  onVideoEnded?: () => void;
}
export const HeroVideo = ({
  activeServiceIndex,
  onVideoEnded
}: HeroVideoProps) => {
  const locale = useLocale();
  const serviceId = heroServiceButtons[activeServiceIndex]?.serviceId ?? 'zep';
  const serviceVideo = heroVideoUrls[serviceId];
  const videoUrl = typeof serviceVideo === 'string' ? serviceVideo : serviceVideo?.[locale] ?? serviceVideo?.['en'] ?? '';
  return <div className="relative z-10 flex w-full justify-center px-quiz-md tablet:px-quiz-lg lg:px-quiz-2xl" data-sentry-component="HeroVideo" data-sentry-source-file="HeroVideo.tsx">
      {/* Video Container */}
      <div className={cn('relative w-full', 'max-w-[968px]', 'aspect-[358/226] md:aspect-[528/334] tablet:aspect-[720/455] lg:aspect-[968/612]', 'bg-quiz-opacity-white-8', 'rounded-t-[22px] tablet:rounded-t-[38px]', 'p-quiz-2xs tablet:p-[10px]')}>
        {/* Video Element */}
        <video key={videoUrl} className={cn('relative w-full h-full', 'rounded-t-quiz-md tablet:rounded-t-quiz-xl', 'border border-[rgba(0,0,0,0.24)]', 'object-cover')} src={videoUrl} autoPlay muted playsInline onEnded={onVideoEnded} />

        {/* Bottom Gradient Overlay */}
        <div className={cn('absolute bottom-0 left-[3px] right-[3px] h-[210px]', 'bg-gradient-to-t from-quiz-white to-transparent', 'pointer-events-none')} />
      </div>
    </div>;
};